module.exports = __webpack_public_path__ + "media/images/muslim-matrimony-banner-3588bed9750dd88774541fff1ac9c99d.jpg";